import { render, staticRenderFns } from "./CreateRemixPage.vue?vue&type=template&id=6ed052c7&scoped=true&"
import script from "./CreateRemixPage.vue?vue&type=script&lang=js&"
export * from "./CreateRemixPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateRemixPage.vue?vue&type=style&index=0&id=6ed052c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed052c7",
  null
  
)

export default component.exports